// 广告媒介类型字典（来源：巡查需求文档，LED电子屏置首为本项目主要场景）

// 行政区划字典（长沙）与「湘江新区」口径转换，统一收口在此，各视图勿再内联。
// 后端库中该区域一律存「岳麓区」，前端按业务口径展示为「湘江新区」：
// 发起查询前用 toBackendDistrict() 转换，接口返回后用 toDisplayDistrict() 转换再渲染。
export const BACKEND_DISTRICT_YUELU = '岳麓区';
export const DISPLAY_DISTRICT_XIANGJIANG = '湘江新区';

export const regionData = [
    {
        name: '湖南省',
        city: [
            {
                name: '长沙市',
                area: ['芙蓉区', '天心区', '湘江新区', '开福区', '雨花区', '望城区', '长沙县', '浏阳市', '宁乡市']
            }
        ]
    }
];

// 查询参数转换：湘江新区 → 岳麓区；其余值（含 ''/null/undefined）原样返回
export function toBackendDistrict(district) {
    return district === DISPLAY_DISTRICT_XIANGJIANG ? BACKEND_DISTRICT_YUELU : district;
}

// 展示转换：岳麓区 → 湘江新区；其余值（含 ''/null/undefined）原样返回
export function toDisplayDistrict(district) {
    return district === BACKEND_DISTRICT_YUELU ? DISPLAY_DISTRICT_XIANGJIANG : district;
}

export const mediaTypeList = [
    'LED电子屏',
    '公交车广告牌',
    '公益广告牌',
    '候车亭广告牌',
    '道闸广告牌',
    '灯箱广告牌',
    '商场广告牌',
    '电梯广告牌',
    '楼宇广告牌',
    '出租车广告牌',
    '地铁广告牌',
    '火车站广告牌',
    '高铁站广告牌',
    '机场广告牌',
    '垃圾桶广告牌',
    '路灯广告牌',
    '墙面广告牌',
    '楼体广告牌',
    '停车场广告牌',
    '顶楼广告牌',
    '高速立柱广告牌',
    '收费站广告牌',
    '三面立柱式广告牌',
    '其他广告牌'
];
